import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { DataResponseHttp } from '../../../../http-models/data-response.http';
import { NotificationQueryHttp } from '../../../../http-models/systems/notification/notification-query.http';
import { StatusResponseHttp } from '../../../../http-models/status-response.http';
import { NotificationUnreadHttp } from '../../../../http-models/systems/notification/notification-unread.http';
import { NotificationInfoHttp } from '../../../../http-models/systems/notification/notification-info.http';

@Injectable({
    providedIn: 'root',
})
export class NotificationHttpService {
    private readonly _httpClient = inject(HttpClient);

    getPaginated(
        params: string
    ): Observable<DataResponseHttp<NotificationQueryHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.notifications}${params}`;
        return this._httpClient.get<DataResponseHttp<NotificationQueryHttp>>(url);
    }

    getUnreads(): Observable<DataResponseHttp<NotificationUnreadHttp[]>> {
        const url = `${environment.api.baseAddress}${environment.api.system.notifications}/unreads`;
        return this._httpClient.get<DataResponseHttp<NotificationUnreadHttp[]>>(url);
    }

    getDownloadLink(id: string): Observable<DataResponseHttp<string>> {
        const url = `${environment.api.baseAddress}${environment.api.system.notifications}/${id}/download-link`;
        return this._httpClient.get<DataResponseHttp<string>>(url);
    }

    getInfo(): Observable<DataResponseHttp<NotificationInfoHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.notifications}/latest`;
        return this._httpClient.get<DataResponseHttp<NotificationInfoHttp>>(url);
    }

    setRead(id: string): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.notifications}/${id}/read`;
        return this._httpClient.put<StatusResponseHttp>(url,null);
    }

    setReadAll(): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.notifications}/read-all`;
        return this._httpClient.put<StatusResponseHttp>(url,null);
    }

    delete(id: string): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.notifications}/${id}`;
        return this._httpClient.delete<StatusResponseHttp>(url);
    }

}
